import React, { Fragment } from 'react';
import { isEmpty } from 'lodash';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { Confirmation } from 'Components/widgets/confirmation/Confirmation';
import { AdditionalAccommodationsList } from './AdditionalAccommodationsList';
type Props = {
  accommodationsSets: Array<AccommodationsSet>;
  error:
    | (HTTPError & {
        errorCode?: string;
      })
    | null
    | undefined;
  filteredAccommodationSets: Array<AccommodationsSet>;
  isDataFetched: boolean;
  onAddAccommodation: (accommodationId: string | null | undefined) => void;
  product: Product;
  proposal: Proposal;
  selectedRate: string;
  setSelectedRate: (arg0: string) => void;
  streetViews?: Array<StreetViewWithAccommodationCategoryId>;
};
export const AdditionalAccommodationsListWrapper = ({
  accommodationsSets,
  error,
  filteredAccommodationSets,
  isDataFetched,
  onAddAccommodation,
  product,
  proposal,
  selectedRate,
  setSelectedRate,
  streetViews,
}: Props) => {
  if (isEmpty(error)) {
    return (
      <Fragment>
        {isDataFetched && accommodationsSets.length === 0 && (
          <div className="mx-auto mb-40 max-w-site-small">
            <Confirmation
              icon={ICONS.CIRCLED_ACCOMMODATION}
              status="neutral"
              text={t('booking.accommodation.moreRooms.noMoreRoomsAvailableDescription')}
              title={t('booking.accommodation.moreRooms.noMoreRoomsAvailableTitle')}
            />
          </div>
        )}

        <AdditionalAccommodationsList
          accommodationsSets={accommodationsSets}
          currency={proposal.price.currency}
          filteredAccommodationSets={filteredAccommodationSets}
          onAddAccommodation={onAddAccommodation}
          product={product}
          proposal={proposal}
          selectedRate={selectedRate}
          setSelectedRate={setSelectedRate}
          streetViews={streetViews}
        />
      </Fragment>
    );
  }

  let errorMessageKey = 'booking.common.layer.unknownErrorDescription';

  if (error.errorCode === 'INVALID_BOOKING_CRITERIA') {
    errorMessageKey = 'booking.accommodation.moreRooms.seller.InvalidBookingCriteria';
  }

  return (
    <div className="mx-auto max-w-site-small">
      <Confirmation
        status="error"
        text={t(errorMessageKey)}
        title={t('booking.common.layer.unknownErrorTitle')}
      />
    </div>
  );
};
